/**
 * OfflineManager - Inicialização e gerenciamento global do modo offline
 */

import syncManager from './SyncManager';
import { openDatabase } from './IndexedDBSetup';

let initialized = false;

export const initializeOffline = async () => {
  if (initialized) return;

  console.log('[OfflineManager] Inicializando...');

  try {
    await openDatabase();
    console.log('[OfflineManager] IndexedDB aberto');

    syncManager.start();
    syncManager.startAutoSync(30000);
    console.log('[OfflineManager] SyncManager iniciado');

    initialized = true;
    console.log('[OfflineManager] Inicialização concluída');
  } catch (error) {
    console.error('[OfflineManager] Erro na inicialização:', error);
    throw error;
  }
};

export const cleanupOffline = () => {
  if (!initialized) return;

  syncManager.stop();
  syncManager.stopAutoSync();
  initialized = false;
  console.log('[OfflineManager] Cleanup concluído');
};

export const getSyncManager = () => syncManager;

export default { initializeOffline, cleanupOffline, getSyncManager };
